(() => {
  if (!document.body.matches('.template-collection, .template-product')) return;

  const mobile = window.matchMedia('(max-width: 768px)');
  const isProduct = document.body.classList.contains('template-product');
  const buttonSelector = '[data-mobile-chat-open]';
  const purchaseSelector = 'block-buy-buttons .add-to-cart, block-buy-buttons .shopify-payment-button';
  let api;
  let ready = false;
  let apiUsable = false;
  let open = false;
  let host;
  let shadow;
  let adapterStyle;
  let shadowObserver;
  let frame;
  let targets = [];
  const visible = new Set();
  const intersection = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (entry.isIntersecting && entry.intersectionRect.width > 0 && entry.intersectionRect.height > 0) visible.add(entry.target);
      else visible.delete(entry.target);
    }
    updateLauncher();
  }) : null;

  function updateLauncher() {
    const enabledInline = document.querySelector(`${buttonSelector}:not([hidden]):not([disabled])`);
    host?.toggleAttribute('data-bs-chat-inline', mobile.matches && isProduct && ready && !!enabledInline && !open && visible.size > 0);
  }

  function restore() {
    host?.removeAttribute('data-bs-chat-mobile');
    host?.removeAttribute('data-bs-chat-inline');
    for (const button of document.querySelectorAll(buttonSelector)) {
      button.hidden = true;
      button.disabled = true;
    }
  }

  function schedule() {
    if (!frame) frame = requestAnimationFrame(() => {
      frame = null;
      sync();
    });
  }

  function bindApi() {
    const next = window.tidioChatApi;
    if (next === api) return;
    ready = false;
    apiUsable = false;
    api = next;
    if (!api || typeof api.on !== 'function' || typeof api.open !== 'function') return;
    const boundApi = api;
    try {
      api.on('ready', () => {
        if (window.tidioChatApi !== boundApi || !apiUsable) return;
        ready = true;
        schedule();
      });
      api.on('beforeOpen', () => {
        open = true;
        host?.removeAttribute('data-bs-chat-inline');
      });
      api.on('open', () => {
        open = true;
        host?.removeAttribute('data-bs-chat-inline');
      });
      api.on('close', () => {
        open = false;
        schedule();
      });
      apiUsable = true;
      ready = typeof api.getStatus === 'function' && ['online', 'offline'].includes(api.getStatus());
    } catch (_) {
      ready = false;
    }
  }

  function sync() {
    bindApi();
    const nextHost = document.getElementById('tidio-chat');
    const nextShadow = nextHost?.shadowRoot;
    if (nextHost !== host || nextShadow !== shadow) {
      restore();
      shadowObserver?.disconnect();
      adapterStyle?.remove();
      host = nextHost;
      shadow = nextShadow;
      adapterStyle = null;
      if (shadow) {
        shadowObserver = new MutationObserver(schedule);
        shadowObserver.observe(shadow, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      }
    }
    const launcher = shadow?.querySelector('#button[data-testid="widgetButton"]');
    const launcherButton = launcher?.querySelector('#button-body[data-testid="widgetButtonBody"]');
    if (!mobile.matches || !ready || !launcherButton || typeof api?.open !== 'function') {
      restore();
      return;
    }
    if (!adapterStyle?.isConnected) {
      adapterStyle = document.createElement('style');
      adapterStyle.textContent = '@media(max-width:768px){:host([data-bs-chat-mobile]) [data-testid="widgetLabel"]{display:none!important}:host([data-bs-chat-mobile][data-bs-chat-inline]) #button.chat-closed{display:none!important}}';
      shadow.append(adapterStyle);
    }
    host.setAttribute('data-bs-chat-mobile', '');
    if (isProduct && intersection) {
      for (const button of document.querySelectorAll(buttonSelector)) {
        button.hidden = false;
        button.disabled = false;
      }
      const nextTargets = [...document.querySelectorAll(purchaseSelector)].filter(element => element.closest('block-buy-buttons')?.querySelector(buttonSelector));
      if (nextTargets.length !== targets.length || nextTargets.some((target, i) => target !== targets[i])) {
        intersection.disconnect();
        visible.clear();
        targets = nextTargets;
        targets.forEach(target => intersection.observe(target));
      }
    }
    updateLauncher();
  }

  document.addEventListener('click', event => {
    const button = event.target.closest?.(buttonSelector);
    if (!button || button.disabled || button.hidden) return;
    event.preventDefault();
    if (!ready || api !== window.tidioChatApi || typeof api?.open !== 'function') {
      restore();
      return;
    }
    try {
      open = true;
      host?.removeAttribute('data-bs-chat-inline');
      api.open();
    } catch (_) {
      open = false;
      restore();
    }
  });
  document.addEventListener('tidioChat-ready', () => {
    bindApi();
    ready = apiUsable;
    schedule();
  });
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('pageshow', schedule);
  mobile.addEventListener('change', schedule);
  new MutationObserver(records => {
    if (records.some(record => record.target.closest?.('block-buy-buttons, #tidio-chat') || [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1 && (node.matches('#tidio-chat, block-buy-buttons') || node.querySelector('#tidio-chat, block-buy-buttons'))))) schedule();
  }).observe(document.body, { childList: true, subtree: true });
  sync();
})();
